import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core'
import { ParkingService } from '../../../services/parking.service'
import {
    Client,
    CreatePaymentMethodResponse,
    Parking,
    PayGateCard,
    PayGateResponse,
    PayGateResultCode,
    PayGateTransactionStatus,
    PaymentMethod,
    paymentMethodsPath,
    PaymentMethodStatus,
    Subscription,
    subscriptionsPath,
    PopupMode,
    ContractStatus,
} from '@parkupp/core'
import { AuthenticationService } from '../../../services/authentication.service'
import { collection, collectionData, doc, docData, Timestamp, updateDoc } from '@angular/fire/firestore'
import { ClientService } from '../../../services/client.service'
import { HttpClient } from '@angular/common/http'
import { Router } from '@angular/router'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { PaymentService } from '../../../services/payment.service'
import { environment } from '../../../../environments/environment'
import { GoogleAnalyticsService } from 'ngx-google-analytics'
import { OmnisendService } from '../../../services/omnisend.service'
import { BackendService } from '../../../services/backend.service'
import { SubscriptionService } from 'src/app/services/subscription.service'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'

@Component({
    selector: 'app-client-choose-payment-method',
    templateUrl: './client-choose-payment-method.component.html',
    styleUrls: ['./client-choose-payment-method.component.scss'],
})
export class ClientChoosePaymentMethodComponent implements OnInit, OnChanges, AfterViewInit {
    PopupMode = PopupMode
    @Input() openPopup: boolean
    @Input() subscriptionReference: string
    @Input() parking: Parking
    @Input() popupMode: PopupMode = PopupMode.CHOOSE_CARD
    @Input() closeOnAdded = false
    @Input() updatingCreditCard = false
    @Input() clientKey: string
    @Output() onClosed = new EventEmitter<void>()

    @ViewChild('paymentMethodsPopup')
    paymentMethodsPopup!: TemplateRef<any>
    bsModalRef: BsModalRef

    paymentMethods: PaymentMethod[]
    selectedPaymentMethod: PaymentMethod
    showAddForm: boolean = false
    showMpiFrame: boolean = false
    clientHasCard: boolean = false

    firestoreUrl: string
    activeClient: Client
    payGateCard: PayGateCard

    mpiIframeUrl: string = ''
    payGateResponse: PayGateResponse
    // subscription: Subscription
    subscriptionLoaded: boolean = false

    formDataPaymentMethod: FormGroup
    formError: string = ''
    formLoading: boolean = false

    landlordLeaseAgreementAccepted = true
    landlordUsePolicyAccepted = true
    parkUppTermsAccepted = true

    paymentMethodUpdating = false

    constructor(
        private paymentService: PaymentService,
        private modalService: BsModalService,
        private router: Router,
        public clientSvc: ClientService,
        private authService: AuthenticationService,
        private parkingSvc: ParkingService,
        private googleAnalyticsService: GoogleAnalyticsService,
        private omnisendService: OmnisendService,
        private subscriptionService: SubscriptionService,
        private http: HttpClient
    ) {
        this.authService.waitForUid().then((user) => {
            // this.authService.auth.currentUser?.uid
            // authService.auth.onAuthStateChanged((user) => {
            let ref = collection(this.parkingSvc.firestore, paymentMethodsPath(user.uid))
            collectionData(ref, { idField: 'documentId' }).subscribe((documents: any[]) => {
                let paymentMethods: PaymentMethod[] = []

                documents.forEach((documentData) => {
                    let paymentMethod = new PaymentMethod(documentData)
                    paymentMethod.$key = documentData.documentId

                    if (paymentMethod.primary) {
                        this.selectedPaymentMethod = paymentMethod
                    }

                    // Ignore failed ones
                    if (paymentMethod.status == PaymentMethodStatus.active) {
                        paymentMethods.push(paymentMethod)
                    }

                    this.clientHasCard = true
                })

                this.paymentMethods = paymentMethods

                if (!this.selectedPaymentMethod && this.paymentMethods[0]) {
                    this.selectedPaymentMethod = this.paymentMethods[0]
                }
            })
        })

        this.formDataPaymentMethod = new FormGroup({
            cardName: new FormControl(null, Validators.required),
            cardNumber: new FormControl(null, Validators.required),
            cardExp: new FormControl(null, Validators.required),
            cardCvv: new FormControl(null, Validators.required),
        })
    }

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        window.addEventListener('message', (event) => {
            if (event.data.action == 'closeMpi') {
                this.popupMode = PopupMode.CHOOSE_CARD
                this.formDataPaymentMethod.reset()
            }
        })
    }

    ngOnChanges(changes: SimpleChanges) {
        // changes.prop contains the old and the new value...
        if (this.openPopup) {
            this.modalService.show(this.paymentMethodsPopup, {
                backdrop: 'static',
                keyboard: false,
            })
        }

        if (this.subscriptionReference) {
            this.subscriptionLoaded = true
            // const docRef = doc(this.clientSvc.firestore, subscriptionsPath(), this.subscriptionReference)
            // getDoc(docRef).then((docSnap) => {
            //     this.subscription = docSnap.data() as Subscription
            //     this.subscription.$key = this.subscriptionReference
            //     this.subscriptionLoaded = true
            // })
        }
    }

    toggleForm() {
        if (this.popupMode == PopupMode.CHOOSE_CARD) {
            this.popupMode = PopupMode.ADD_CARD
        } else {
            this.popupMode = PopupMode.CHOOSE_CARD
        }
    }

    reset() {
        this.openPopup = false
        this.closeModal()
    }

    closeModal() {
        this.modalService.hide()
        this.onClosed.emit()
    }

    howItWorksModal() {
        this.popupMode = PopupMode.HOW_IT_WORKS
    }

    exitHowItWorks() {
        this.popupMode = PopupMode.CHOOSE_CARD
    }

    changeSelectedCard(key: any) {
        this.selectedPaymentMethod = this.paymentMethods.find((i) => i.$key == key) as PaymentMethod
    }

    toggleLandlordUsePolicyAccepted() {
        this.landlordUsePolicyAccepted = !this.landlordUsePolicyAccepted
    }

    toggleParkUppTermsAccepted() {
        this.parkUppTermsAccepted = !this.parkUppTermsAccepted
    }

    toggleLandlordLeaseAgreementAccepted() {
        this.landlordLeaseAgreementAccepted = !this.landlordLeaseAgreementAccepted
    }

    updatePaymentMethod() {
        this.paymentMethodUpdating = true
        docData(doc(this.paymentService.firestore, subscriptionsPath(), this.subscriptionReference)).subscribe((documentData: any) => {
            const subscription = new Subscription(documentData)
            subscription.$key = this.subscriptionReference

            // console.log(subscription.clientRef.id)
            const paymentRef = doc(this.paymentService.firestore, `${paymentMethodsPath(subscription.clientRef.id)}/${this.selectedPaymentMethod.$key}`)
            // console.log(paymentRef.id)
            updateDoc(doc(this.paymentService.firestore, subscriptionsPath(), subscription.$key), {
                paymentMethodRef: paymentRef,
            }).then(() => {
                this.paymentMethodUpdating = false
                location.reload()
            })
        })
        // console.log(this.selectedPaymentMethod)
    }

    async httpProcessTokenPayment() {
        this.formLoading = true
        await this.authService.waitForUid()

        try {
            const response: any = await this.paymentService.httpProcessTokenPaymentCreateSubscription(this.selectedPaymentMethod, this.subscriptionReference)
            console.log(response)

            if (!response.error) {
                this.popupMode = PopupMode.COMPLETE

                // Get subscription data once
                const subscriptionDoc = await docData(doc(this.paymentService.firestore, subscriptionsPath(), this.subscriptionReference)).pipe(take(1)).toPromise()
                if (!subscriptionDoc) {
                    throw new Error('Subscription document not found')
                }

                const subscription = new Subscription(subscriptionDoc)
                subscription.$key = this.subscriptionReference

                if (subscriptionDoc['parkingRef']) {
                    const parkingDoc = await docData(subscriptionDoc['parkingRef']).pipe(take(1)).toPromise()
                    if (parkingDoc) {
                        subscription.$parking = new Parking(parkingDoc)
                        subscription.$parking.$key = subscriptionDoc['parkingRef'].id
                    }
                }

                // Create order only once after successful payment
                await this.omnisendService.createOrder({
                    activeClient: this.clientSvc.activeClient!,
                    subscriptionKey: subscription.$key!,
                    parking: subscription.$parking!,
                    quantity: subscription.baysBooked * subscription.period,
                    priceInCents: this.parking.defaultPriceInCents,
                    orderTotal: subscription.totalContractValue,
                })

                this.googleAnalyticsService.event('purchase', subscription.$parking?.parkingType, subscription.$parking?.title, subscription.totalContractValue / 100)
            } else {
                this.formError = response.resultDescription
            }
        } catch (error) {
            console.error('Payment processing error:', error)
            this.formError = 'An error occurred while processing your payment'
        } finally {
            this.formLoading = false
        }
    }

    httpCreatePaymentMethod() {
        this.formLoading = true
        this.formError = ''

        let payGateCard = new PayGateCard({
            cardNumber: this.formDataPaymentMethod.value.cardNumber.replace(/\s/g, ''),
            cardExp: this.formDataPaymentMethod.value.cardExp.replace(/-/g, '').replace(/\//g, ''),
            cardCvv: this.formDataPaymentMethod.value.cardCvv,
            nameOnCard: this.formDataPaymentMethod.value.cardName,
        })

        if (this.clientSvc.activeClient) {
            this.paymentService.httpCreatePaymentMethod(this.subscriptionReference, payGateCard, this.clientSvc.activeClient).then((response: CreatePaymentMethodResponse) => {
                this.formLoading = false

                if (response?.payGateResponse) {
                    if (response.payGateResponse.error && response.payGateResponse.error[0]) {
                        const errorMessage = response.payGateResponse.error[0]['_text']

                        if (errorMessage.includes("maxLength '4' for type 'CvvType'")) {
                            this.formError = 'Input Error: CVV Number looks too long'
                        } else if (errorMessage.includes("minLength '3' for type 'CvvType'")) {
                            this.formError = 'Input Error: CVV Number looks too short'
                        } else if (errorMessage.includes("maxLength '19' for type 'CardNumberType'")) {
                            this.formError = 'Input Error: Card number looks too long'
                        } else if (errorMessage.includes("minLength '13' for type 'CardNumberType'")) {
                            this.formError = 'Input Error: Card number Number looks too short'
                        } else if (errorMessage.includes("for type 'CardDateType'")) {
                            this.formError = 'Invalid date format, please use: 09/2025'
                        } else {
                            this.formError = response.payGateResponse.error[0]['_text']
                        }
                    } else if (response.payGateResponse?.resultCode == PayGateResultCode['notProvided']) {
                        if (response.payGateResponse.resultDescription) {
                            this.formError = response.payGateResponse.resultDescription
                        }
                    } else if (response.payGateResponse?.resultCode) {
                        if (response.payGateResponse.resultCode in PayGateResultCode) {
                            if (PayGateResultCode[response.payGateResponse.resultCode]) {
                                this.formError = `Card error: ${PayGateResultCode[response.payGateResponse.resultCode]}`
                            }
                        }
                    }

                    if (response.payGateResponse.redirectUrl) {
                        // If MPI:
                        localStorage.setItem('payRequestId', response.payGateResponse.payRequestId as string)
                        localStorage.setItem('paygateId', response.payGateResponse.paygateId as string)
                        localStorage.setItem('checksum', response.payGateResponse.checksum as string)
                        localStorage.setItem('redirectUrl', response.payGateResponse.redirectUrl as string)

                        // Change the popup to the 3D secure iFrame
                        this.popupMode = PopupMode.OTP_SECURE
                        this.showAddForm = false
                        this.mpiIframeUrl = `${environment.host}/paygate-request`
                    }

                    if (response.payGateResponse.transactionStatusCode == PayGateTransactionStatus['Approved']) {
                        if (this.closeOnAdded) {
                            this.closeModal()
                        } else {
                            this.popupMode = PopupMode.CHOOSE_CARD
                        }
                    }
                } else {
                    // TODO: DEBUG this
                    this.formError = 'Unknown error: Please contact us - 084 590 2401'
                }
            })
        } else {
            setTimeout(() => {
                this.httpCreatePaymentMethod()
            }, 100)
        }
    }

    closeToMap() {
        this.closeModal()
        this.router.navigate(['/map-search'])
    }

    closeToProfile() {
        this.closeModal()
        this.router.navigate([`/client/${this.clientSvc.activeClient?.$key}/vehicles`])
    }

    getMonthlyFee(): number {
        return this.parking.defaultPriceInCents / 100
    }

    checkExpiryDate(event: any) {
        const expiryDate = event.target.value
        const regex = /^(\d{2})\/(\d{2})$/
        if (regex.test(expiryDate)) {
            const [_, month, year] = expiryDate.match(regex)
            const fullYear = `20${year}`
            this.formDataPaymentMethod.get('cardExp')?.setValue(`${month}/${fullYear}`)
        }
    }
}
